import { render, staticRenderFns } from "./TextMessageBalloon.vue?vue&type=template&id=068e1b87&scoped=true&"
import script from "./TextMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./TextMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./TextMessageBalloon.vue?vue&type=style&index=0&id=068e1b87&lang=less&scoped=true&"
import style1 from "./TextMessageBalloon.vue?vue&type=style&index=1&lang=css&"
import style2 from "./TextMessageBalloon.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e1b87",
  null
  
)

export default component.exports